<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.35 38.9609V8.26955H5V28.45H22.9609V12.5195H38.75C40.9225 12.5195 42.7823 13.2931 44.3294 14.8401C45.8765 16.3872 46.65 18.247 46.65 20.4195V38.9609H43V32.4109H5V38.9609H1.35ZM13.6828 25.7195C12.0886 25.7195 10.748 25.1782 9.661 24.0956C8.57397 23.013 8.03045 21.6746 8.03045 20.0804C8.03045 18.4862 8.57175 17.1525 9.65435 16.0793C10.7369 15.0061 12.0753 14.4695 13.6695 14.4695C15.2638 14.4695 16.5975 15.0039 17.6706 16.0727C18.7438 17.1414 19.2804 18.4729 19.2804 20.0671C19.2804 21.6613 18.7461 23.002 17.6773 24.089C16.6086 25.176 15.2771 25.7195 13.6828 25.7195ZM26.6392 28.45H43V20.4292C43 19.254 42.5838 18.2503 41.7515 17.418C40.9192 16.5857 39.9187 16.1695 38.75 16.1695H26.6392V28.45ZM13.6695 22.3804C14.3029 22.3804 14.8445 22.1554 15.2945 21.7054C15.7445 21.2554 15.9695 20.7138 15.9695 20.0804C15.9695 19.4471 15.7445 18.9054 15.2945 18.4554C14.8445 18.0054 14.3029 17.7804 13.6695 17.7804C13.0362 17.7804 12.4945 18.0054 12.0445 18.4554C11.5945 18.9054 11.3695 19.4471 11.3695 20.0804C11.3695 20.7138 11.5945 21.2554 12.0445 21.7054C12.4945 22.1554 13.0362 22.3804 13.6695 22.3804Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
